import React from 'react';
import { Avatar } from 'antd';
import Router from 'next/router';
import * as timeago from 'timeago.js';
import Identicon from 'react-identicons';
import { NotificationItem } from '../lib/models/GeneralModels';

export const NotificationCard = ({
  notificationData,
}: {
  notificationData: NotificationItem;
}) => {
  async function onContentClicked() {
    await Router.push(`/nft/${notificationData.nftBaseID}`);
  }

  async function onAvatarClicked() {
    await Router.push(`/creators/${notificationData.fromUser.walletAddress}`);
  }

  return (
    <div className="notification-item">
      <div
        onClick={onAvatarClicked}
        onKeyDown={onAvatarClicked}
        role="presentation"
        className="notification-item-avatar"
      >
        {notificationData?.fromUser?.userAvatarUrlCompressed ||
        notificationData?.fromUser?.userAvatarUrl ? (
          <img
            src={
              notificationData.fromUser.userAvatarUrlCompressed ||
              notificationData.fromUser.userAvatarUrl
            }
            width={44}
            height={44}
            style={{ borderRadius: '30px' }}
            alt="User avatar"
          />
        ) : (
          <Avatar
            shape="circle"
            size={44}
            src={
              <Identicon string={notificationData.fromUserAddress} size={44} />
            }
          />
        )}
      </div>

      <div
        className="notification-item-column"
        onClick={onContentClicked}
        onKeyDown={onContentClicked}
        role="presentation"
      >
        <>
          <div className="notification-item-username">
            {notificationData?.fromUser?.username ||
              notificationData.fromUserAddress}
          </div>
          <div className="notification-item-column-content">
            {notificationData.content}{' '}
            <span className="content-time">
              {timeago.format(notificationData.createdAt)}
            </span>
          </div>
        </>
      </div>
    </div>
  );
};
